import axios from "../axios";
import axiosJson from "../axiosJson";
import errorHandler from "../error-handler";

export const taxSearch = (year, data) =>
    new Promise((resolve, reject) =>
        axios
            .get(`/tax_year/${year}/search`, {
                params: data,
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );

export const taxFilter = (year, data) =>
    new Promise((resolve, reject) =>
        axiosJson
            .post(`/tax_year/${year}/filter`, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );
